import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemMediaIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21 2.45001H10C8.48 2.45001 7.25 3.68001 7.25 5.20001V5.75001H6C4.76 5.75001 3.75 6.76001 3.75 8.00001V9.05001H2C1.04 9.05001 0.25 9.84001 0.25 10.8V19.8C0.25 20.76 1.04 21.55 2 21.55H15C15.96 21.55 16.75 20.76 16.75 19.8V18.25H18C19.24 18.25 20.25 17.24 20.25 16V14.95H21C22.52 14.95 23.75 13.72 23.75 12.2V5.20001C23.75 3.68001 22.52 2.45001 21 2.45001ZM15.25 19.8C15.25 19.94 15.14 20.05 15 20.05H2C1.86 20.05 1.75 19.94 1.75 19.8V10.8C1.75 10.66 1.86 10.55 2 10.55H15C15.14 10.55 15.25 10.66 15.25 10.8V19.8ZM18.75 16C18.75 16.41 18.41 16.75 18 16.75H16.75V10.8C16.75 9.84001 15.96 9.05001 15 9.05001H5.25V8.00001C5.25 7.59001 5.59 7.25001 6 7.25001H18C18.41 7.25001 18.75 7.59001 18.75 8.00001V16ZM22.25 12.2C22.25 12.89 21.69 13.45 21 13.45H20.25V8.00001C20.25 6.76001 19.24 5.75001 18 5.75001H8.75V5.20001C8.75 4.51001 9.31 3.95001 10 3.95001H21C21.69 3.95001 22.25 4.51001 22.25 5.20001V12.2Z"
        fill={color}
      />
      <path
        d="M11.27 14.74L6.77002 12.54C6.37002 12.33 5.86002 12.65 5.87002 13.1V17.5C5.86002 17.95 6.37002 18.27 6.77002 18.06L11.27 15.86C11.73 15.65 11.73 14.94 11.27 14.74ZM7.12002 16.5V14.1L9.57002 15.3L7.12002 16.5Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemMediaIcon.displayName = 'ItemMediaIcon';
